export default __webpack_public_path__ + "static/media/guesser-img.045bce63.png";